import { defHttp } from '/@/utils/http/axios'

const URL_PREFIX = '/workorder-center'

/**
 * 判断当前登录人是否是服务站用户（Apifox：GET /api/user-info/is-station-user）
 * ADMIN/TECHNICIAN/ADMIN_TAG/TECHNICIAN_TAG 任一即返回 true
 */
export function getIsStationUser(userId: string | number) {
  return defHttp.get<boolean>(
    {
      url: `${URL_PREFIX}/api/user-info/is-station-user`,
      headers: {
        'X-USER-ID': String(userId),
      },
    },
    {
      errorMessageMode: 'none',
    },
  )
}
